import type { FaireProductEntity } from "../../entity_types/product";

export const p_zz8fkm4m76: FaireProductEntity = {
  token: "p_zz8fkm4m76",
  type: "product",
  name: "Pink Palms Note Card Set of 10",
  brandToken: "b_8tt4uz6vzm",
  brandName: "Empress Stationery",
  imageUrl:
    "https://cdn.faire.com/fastly/ade255837ef9ba2dc31fe2d67427e835ef5ec678a6ecfe4a22194dba9af98cfd.jpeg",
  galleryImageUrls: [],
  priceDollars: 18,
  description:
    'Our Pink Palms Boxed Note Set includes 10 premium folded correspondence cards with coordinating patterned envelope liners, beautifully packaged for effortless gifting. A timeless stationery staple for handwritten notes, thank-you cards, and everyday correspondence.\n\nDETAILS\n\n* Set of 10 flat cards and envelopes with patterned liners\n* Card size: 5.5" x 4.25"\n* Packaged as a box set\n* Printed on 120 pound Ivory eggshell finish paper\n* Ivory envelopes with Patterned Liner\n* Printed and packaged in the USA\n\nBETTER PAPER, BETTER PRODUCT\n\nPrinted on our signature 120 pound eggshell paper, each note card offers the same exceptional quality trusted for our luxury wedding stationery. The rich texture and substantial weight create an elegant first impression that ordinary card stock simply can\'t achieve.\n\n* Heirloom-quality 120 pound eggshell paper \n* Beautifully textured for an elevated writing experience \n* Substantial weight with a refined, luxurious feel \n* The same premium stock featured throughout our wedding collection\n\nWe are always happy to mail a sample so you can see and feel the difference! Simply drop us a message.',
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:55.299Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
